var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block__content"},[_c('Paragraph',{attrs:{"size":_vm.data.textSize,"text":_vm.data.text,"data-anim":"text","data-view":"false"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }